import { initializeApp, getApps, type FirebaseApp, type FirebaseOptions } from 'firebase/app';
import { getAuth, onAuthStateChanged, type User } from 'firebase/auth';
import { getFirestore, type Firestore } from 'firebase/firestore';

export type FirebaseCtx = { app: FirebaseApp; auth: ReturnType<typeof getAuth>; db: Firestore };

let ctx: FirebaseCtx | null = null;
let currentUser: User | null = null;

function getConfigFromEnv(): FirebaseOptions | null {
  const cfg: Partial<FirebaseOptions> = {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY as string | undefined,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN as string | undefined,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID as string | undefined,
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET as string | undefined,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID as string | undefined,
    appId: import.meta.env.VITE_FIREBASE_APP_ID as string | undefined,
  };
  if (!cfg.apiKey || !cfg.authDomain || !cfg.projectId || !cfg.appId) return null;
  return cfg as FirebaseOptions;
}

export async function initFirebase(): Promise<FirebaseCtx | null> {
  if (ctx) return ctx;
  const config = getConfigFromEnv();
  if (!config) return null; // 未設定なら同期を無効化
  const app = getApps().length ? getApps()[0]! : initializeApp(config);
  const auth = getAuth(app);
  const db = getFirestore(app);
  ctx = { app, auth, db };
  onAuthStateChanged(auth, (u) => (currentUser = u));
  return ctx;
}

export function getCurrentUser() {
  return currentUser;
}
